import React, { useEffect, useState } from 'react';
import { MdEventBusy } from 'react-icons/md';
import '../../styles/Events/eventDetail.css';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../settings';
import moment from 'moment';

export default function EventDetail() {
    const navigate = useNavigate();
    const [fetchedAnnouncement, setFetchedAnnouncement] = useState({});
    const [announcementFound, setAnnouncementFound] = useState(false);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        let path = window.location.pathname?.split('/');
        let id = path[path?.length - 1];

        // 👇️ fetch event by id
        fetch(`${BASE_URL}/announcements/read`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id }),
        })
            .then(async (response) => {
                let data = await response.json();
                setAnnouncementFound(true);

                let the_announcement = data?.announcement;
                setFetchedAnnouncement(the_announcement);
            })
            .catch((error) => {
                if (error?.message == 'Failed to fetch') {
                    displaySnackbar('Could not reach the servers', true);
                    setAnnouncementFound(false);
                } else {
                    displaySnackbar('Could not fetch announcement.', true);
                    setAnnouncementFound(false);
                }
            });
    }, []);

    return announcementFound ? (
        <div className='infoboard-event-detail-container'>
            <button onClick={() => navigate(-1)} className='go-back-btn'>
                👈️ Go Back
            </button>

            <div className='header'>
                <h1>Announcement Detail</h1>
            </div>

            <div className='details-content-item'>
                <span className='title'>Details</span>
                {fetchedAnnouncement?.details?.length > 0 ? (
                    <p className='text about'>{fetchedAnnouncement?.details}</p>
                ) : (
                    <p className='empty-text'>...</p>
                )}
            </div>

            <div className='details-content-items'>
                <div className='details-content-item'>
                    <span className='title'>Title</span>
                    {fetchedAnnouncement?.title?.length > 0 ? (
                        <p className='text'>{fetchedAnnouncement?.title}</p>
                    ) : (
                        <p className='empty-text'>...</p>
                    )}
                </div>

                <div className='details-content-item'>
                    <span className='title'>Announcened on</span>
                    {fetchedAnnouncement?.createdAt?.length > 0 ? (
                        <p className='text'>
                            {moment(new Date(fetchedAnnouncement?.createdAt)).calendar()}
                        </p>
                    ) : (
                        <p className='empty-text'>...</p>
                    )}
                </div>
            </div>
        </div>
    ) : (
        <div className='event-not-found-container'>
            <MdEventBusy size={100} color='#777' className='event-not-found-icon' />
            <span> annoucement not found </span>
        </div>
    );
}
